export default __webpack_public_path__ + "static/media/105.cc617c14.jpeg";